import PropTypes from 'prop-types';

import { formatDate } from '../../utils';

Time.propTypes = {
  date: PropTypes.instanceOf(Date).isRequired,
  format: PropTypes.string,
};

/**
 * Displays a date both in human readable and machine readable form.
 *
 * Formatting docs: https://date-fns.org/docs/format
 */
export default function Time({ date, format }) {
  return <time dateTime={date.toISOString()}>{formatDate(date, format)}</time>;
}
